module.exports = __STORYBOOK_MODULE_CHANNELS__;